import React from 'react';

import { Button } from '@eika/button';
import { WarningCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import useTranslation from '../../../hooks/useTranslation';

import './MissingToAccountInfo.scss';

interface Props {
    onSelect?: () => void;
}

const MissingToAccountInfo: React.FC<Props> = ({ onSelect }) => {
    const translated = useTranslation();
    return (
        <WarningCard
            isModal
            title={translated.missingToAccountTransfer.title}
            icon={<RichIcon type={RichIconTypes.LYSPARE} />}
        >
            <div>
                <section className="missing-to-account-info__section">
                    <h3 className="missing-to-account-info__section-header">
                        {translated.missingToAccountTransfer.tip}
                    </h3>
                    <div>{translated.missingToAccountTransfer.description}</div>
                </section>
                {onSelect && (
                    <Button size="small" onClick={onSelect}>
                        {translated.missingToAccountTransfer.buttonText}
                    </Button>
                )}
            </div>
        </WarningCard>
    );
};

export default MissingToAccountInfo;
